import { OtherServices } from '../types/common-items';

export const UPDATE_OTHER_SERVICES = 'UPDATE_OTHER_SERVICES';

export const updateOtherServices = (payload: OtherServices) => ({
    type: UPDATE_OTHER_SERVICES,
    payload,
});

export default (state = [] as OtherServices, action: ReturnType<typeof updateOtherServices>) =>
    action.type === UPDATE_OTHER_SERVICES ? action.payload : state;
